// src/pages/admin/Page_Formacion/Page_Formacion.js
//
// Panel admin de Formacion EDUCA360 K12: gestiona los videos, guias PDF e
// informacion de uso de la plataforma que ven el profesor
// (/portal/teacher/formacion) y la institucion (/portal/inst/formacion).
//
// Apartado SEPARADO del de REVI: distinta coleccion, distinto endpoint y
// distinta entrada de menu. Comparte con REVI los componentes de gestion
// (FormacionManager), no los datos.

import React from "react";
import { TrainingResourceAPI } from "../../../api";
import { useAuth } from "../../../hooks";
import { PageHeader, EducaThemeProvider } from "../../../ui";
import { FormacionManager } from "../../../components/Admin/FormacionCmp";
import styles from "./Page_Formacion.module.scss";

const api = new TrainingResourceAPI();

// A nivel de modulo para mantener la referencia estable entre renders.
const AUDIENCE_OPTIONS = [
  { value: "teacher", label: "Profesores" },
  { value: "institution", label: "Instituciones" },
];

const INFO_BLOCKS = [
  {
    audience: "teacher",
    title: "Información para profesores",
    titlePlaceholder: "Ej. Primeros pasos en Educa360",
    descriptionPlaceholder:
      "Texto de bienvenida y presentación que verá el profesor en su página de Formación.",
    emptyText: "Aún no hay información para profesores",
  },
  {
    audience: "institution",
    title: "Información para instituciones",
    titlePlaceholder: "Ej. Gestión de tu centro en Educa360",
    descriptionPlaceholder:
      "Texto de bienvenida y presentación que verá el responsable del centro.",
    emptyText: "Aún no hay información para instituciones",
  },
];

export function Page_Formacion() {
  const { accessToken } = useAuth();

  return (
    <EducaThemeProvider>
      <div className={styles.pageFormacion}>
        <PageHeader
          title="Formación K12"
          subtitle="Vídeos, guías PDF e información de uso de la plataforma para profesores e instituciones de Educa360."
        />
        <FormacionManager
          api={api}
          accessToken={accessToken}
          audienceOptions={AUDIENCE_OPTIONS}
          infoBlocks={INFO_BLOCKS}
        />
      </div>
    </EducaThemeProvider>
  );
}
